// models
import type { SystemStateProps } from '../models/system.model';

// libraries
import { atom } from 'recoil';

// [시스템 코드 대분류]
// - Category: clsCd = 0, optCd = 1

// [시스템 코드 중분류]
// - Designation : clsCd = 1, optCd = 2
// - Discipline : clsCd = 1, optCd = 3
// - Occupation : clsCd = 1, optCd = 20
// - Zone : clsCd = 1, optCd = 21

// [시스템 코드 소분류]
// - Designation 하위 항목: cLsCd = 2
// - Discipline 하위 항목: cLsCd = 3
// - Occupation 하위 항목: cLsCd = 20
// - Zone 하위 항목: cLsCd = 21

// [Company Type]
// - Company Type: clsCd = 4

// [안전교육 대분류]
// - 안전교육 대분류: clsC

/** category */
export const CategoryAtom = atom<SystemStateProps['category']>({
  key: 'CategoryAtom',
  default: {
    list: [],
    options: []
  }
});

/** designation */
export const DesignationAtom = atom<SystemStateProps['designation']>({
  key: 'DesignationAtom',
  default: {
    list: [],
    options: []
  }
});

/** discipline */
export const DisciplineAtom = atom<SystemStateProps['discipline']>({
  key: 'DisciplineAtom',
  default: {
    list: [],
    options: []
  }
});

/** occupation */
export const OccupationAtom = atom<SystemStateProps['occupation']>({
  key: 'OccupationAtom',
  default: {
    list: [],
    options: []
  }
});

/** zone */
export const ZoneAtom = atom<SystemStateProps['zone']>({
  key: 'ZoneAtom',
  default: {
    list: [],
    options: []
  }
});

/** religion */
export const ReligionAtom = atom<SystemStateProps['religion']>({
  key: 'ReligionAtom',
  default: {
    list: [],
    options: []
  }
});

/** race */
export const RaceAtom = atom<SystemStateProps['race']>({
  key: 'RaceAtom',
  default: {
    list: [],
    options: []
  }
});

/** companyType */
export const CompanyTypeAtom = atom<SystemStateProps['companyType']>({
  key: 'CompanyTypeAtom',
  default: {
    list: [],
    options: []
  }
});

/** training */
export const TrainingAtom = atom<SystemStateProps['category']>({
  key: 'TrainingAtom',
  default: {
    list: [],
    options: []
  }
});
